<app-page-header [title]="'navigation.factors' | transloco">
  <p-button
    [label]="'factorPage.addFactor' | transloco"
    icon="pi pi-plus"
    (onClick)="openCreateDialog()"
  />
</app-page-header>
<p class="text-paragraph-md-reg mb-8 mt-4 text-primary-700">
  {{ "factorPage.explanation" | transloco }}
</p>

<div class="mb-4 flex items-center gap-3">
  <div
    class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100"
  >
    <lucide-icon
      name="chartNoAxesCombined"
      class="text-primary-600"
      [size]="16"
    ></lucide-icon>
  </div>
  <h2
    class="flex items-baseline gap-1 text-lg font-semibold text-greyscale-800"
  >
    {{ "factorPage.sectionTitle" | transloco }}

    <app-tooltip-icon
      [message]="'factorPage.infoCardDescription' | transloco"
      position="right"
      iconClass="text-greyscale-400"
    />
  </h2>
</div>
<div class="mb-4 h-px bg-greyscale-200"></div>

<!-- Explanation + Warning -->

<div>
  @if (factors().length == 0) {
    <section>
      <div class="flex flex-col items-center justify-center py-12 text-center">
        <div class="mb-4 rounded-full bg-greyscale-100 p-4">
          <lucide-icon
            name="chartNoAxesCombined"
            class="text-greyscale-400"
            [size]="16"
          ></lucide-icon>
        </div>
        <h3 class="mb-2 text-xl font-semibold text-greyscale-900">
          {{ "factorPage.emptyTitle" | transloco }}
        </h3>
        <p class="mb-6 max-w-md text-sm text-greyscale-600">
          {{ "factorPage.emptyDescription" | transloco }}
        </p>
        <p-button
          [label]="'factorPage.addFactor' | transloco"
          icon="pi pi-plus"
          (onClick)="openCreateDialog()"
          data-testid="empty-state-add-factor"
        ></p-button>
      </div>
    </section>
  } @else {
    <div class="overflow-x-auto">
      <table class="w-full text-left">
        <thead>
          <tr class="border-b border-greyscale-200 bg-greyscale-50">
            <th class="px-3 py-2 text-paragraph-xs-med text-greyscale-600">
              {{ "factorPage.dialog.name" | transloco }}
            </th>
            <th class="px-3 py-2 text-paragraph-xs-med text-greyscale-600">
              {{ "factorPage.dialog.category.label" | transloco }}
            </th>
            <th class="px-3 py-2 text-paragraph-xs-med text-greyscale-600">
              {{ "factorPage.dialog.source" | transloco }}
            </th>
            <th
              class="px-3 py-2 text-right text-paragraph-xs-med text-greyscale-600"
            >
              {{ "factorPage.table.colValuePerKm" | transloco }}
            </th>
            <th
              class="px-3 py-2 text-right text-paragraph-xs-med text-greyscale-600"
            >
              {{ "factorPage.table.colValuePerH" | transloco }}
            </th>
            <!-- <th
              class="px-3 py-2 text-right text-paragraph-xs-med text-greyscale-600"
            >
              {{ "factorPage.dialog.speed" | transloco }}
            </th> -->
            <th
              class="px-3 py-2 text-right text-paragraph-xs-med text-greyscale-600"
            >
              {{ "factorPage.table.colValuePerNight" | transloco }}
            </th>
            <th
              class="px-3 py-2 text-right text-paragraph-xs-med text-greyscale-600"
            >
              {{ "factorPage.dialog.uncertainty" | transloco }}
            </th>
            <th class="px-3 py-2"></th>
          </tr>
        </thead>
        <tbody>
          @for (factor of factors(); track factor.id) {
            <tr class="border-b border-greyscale-100 hover:bg-greyscale-50">
              <td class="px-3 py-2 text-paragraph-s-med text-greyscale-800">
                {{ factor.name }}
              </td>
              <td class="px-3 py-2 text-paragraph-s-reg text-greyscale-600">
                {{ "calculator." + factor.category | transloco }}
              </td>
              <td class="px-3 py-2 text-paragraph-s-reg text-greyscale-600">
                <span
                  class="block max-w-[200px] truncate"
                  [pTooltip]="factor.source ?? ''"
                  [tooltipDisabled]="!factor.source || factor.source.length <= 30"
                  tooltipPosition="top"
                >
                  {{ factor.source ?? "—" }}
                </span>
              </td>
              <td
                class="px-3 py-2 text-right text-paragraph-s-reg text-greyscale-600"
              >
                {{ factor.valuePerKm ?? "—" }}
              </td>
              <td
                class="px-3 py-2 text-right text-paragraph-s-reg text-greyscale-600"
              >
                {{ factor.valuePerH ?? "—" }}
              </td>
              <!-- <td
                class="px-3 py-2 text-right text-paragraph-s-reg text-greyscale-600"
              >
                {{ factor.speed ?? "—" }}
              </td> -->
              <td
                class="px-3 py-2 text-right text-paragraph-s-reg text-greyscale-600"
              >
                {{ factor.valuePerNight ?? "—" }}
              </td>
              <td
                class="px-3 py-2 text-right text-paragraph-s-reg text-greyscale-600"
              >
                {{
                  factor.uncertainty !== null ? factor.uncertainty + " %" : "—"
                }}
              </td>
              <td class="px-3 py-2">
                <div class="flex items-center justify-end gap-1">
                  <p-button
                    icon="pi pi-pencil"
                    [text]="true"
                    size="small"
                    severity="secondary"
                    (onClick)="openEditDialog(factor)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [text]="true"
                    size="small"
                    severity="danger"
                    (onClick)="confirmDelete(factor)"
                  />
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
<app-factor-form-dialog
  [(visible)]="dialogVisible"
  [mode]="dialogMode"
  [factor]="selectedFactor"
  [loading]="dialogLoading"
  (save)="submit($event)"
/>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
